import { TTypeParameter } from "@pages/DataBase/Parameters/DataGridParameterSettings";
import { decommissionData, fetchData } from "@redux/slices/functionals/request/requestActions";
import { CEntity, CParameter, IEntity, ISessionBadge } from "@ts/ui-models";


export const getParameters = async (dispatch, type: TTypeParameter, xTypeId: string | null, badge: ISessionBadge): Promise<CParameter[] | null> => {
    const result = await dispatch(
        fetchData({
            url: '/api/parameters',
            meta: {
                "type": type,
                "xTypeId": xTypeId,
                //"organizationId": badge.organizationId,
                //"roleId": badge.roleId
            }
        })
    );
    if (result?.payload?.data) {
        return result.payload.data.map((item: any) => new CParameter(item));
    }
    return null;
};

export const getParameterAvailables = async (dispatch, type: TTypeParameter, xTypeId: string | null, badge: ISessionBadge): Promise<CEntity<IEntity>[] | null> => {
    const result = await dispatch(
        fetchData({
            url: '/api/parameterTypesAvailable',
            meta: {
                "type": type,
                "xTypeId": xTypeId,
                //"organizationId": badge.organizationId,
                //"roleId": badge.roleId
            }
        })
    );
    if (result?.payload?.data) {
        return result.payload.data.map((item: any) => new CEntity(item));
    }
    return null;
};

export const decomissionUnsetParameter = async (dispatch, type: TTypeParameter, xTypeId: string | null, badge: ISessionBadge, parameterId: string): Promise<string[] | null> => {
    const result = await dispatch(
        decommissionData({
            url: '/api/unsetParameter',
            dataBody: {
                "parameterId": parameterId,
                "type": type,
                "xTypeId": xTypeId,
                //"organizationId": badge.organizationId,
                //"roleId": badge.roleId
            },
            /* meta: {
                "dataPath": "decommission",
                "data": {
                    "parameterId": "4e699301-94ef-4083-8310-e5f2e2415402",
                    "type": "organization",
                    "xTypeId": "ORG_TRACKTIO"
                },
                "organizationId": "ORG_TRACKTIO",
                "roleId": "TKTIO_ROLE_ADMIN"
            } */
        })
    );
    if (result?.payload?.data) {
        return result.payload.data;
    }
    return null;
};